import { useState } from 'react';
import { ExternalLink, Menu, MessageCircle, ShoppingBag, X } from 'lucide-react';
import { Link, NavLink } from 'react-router-dom';

function Navbar() {
    const [menuOpen, setMenuOpen] = useState(false);

    const closeMenu = () => setMenuOpen(false);

    return (
        <header className="site-header">
            <div className="announcement-bar">
                <span>Pepe is legendary. A legend is born with every Pepe.</span>
                <a href="https://thepepes.com/" target="_blank" rel="noreferrer">
                    Visit ThePepes.com <ExternalLink size={14} aria-hidden="true" />
                </a>
            </div>
            <div className="nav-shell">
                <div className="nav-inner">
                    <Link to="/" className="brand-link" onClick={closeMenu} aria-label="The Pepes Community home">
                        <img src="/logo.png" alt="The Pepes" />
                        <span>Community Board</span>
                    </Link>
                    <button
                        className="menu-button"
                        type="button"
                        aria-label={menuOpen ? 'Close navigation' : 'Open navigation'}
                        aria-expanded={menuOpen}
                        aria-controls="primary-navigation"
                        onClick={() => setMenuOpen((open) => !open)}
                    >
                        {menuOpen ? <X aria-hidden="true" /> : <Menu aria-hidden="true" />}
                    </button>
                    <div className={`nav-content${menuOpen ? ' is-open' : ''}`} id="primary-navigation">
                        <nav className="primary-nav" aria-label="Primary navigation">
                            <NavLink to="/" end onClick={closeMenu}>Home</NavLink>
                            <NavLink to="/leaderboards" onClick={closeMenu}>Leaderboards</NavLink>
                            <NavLink to="/holders" onClick={closeMenu}>Top Holders</NavLink>
                        </nav>
                        <div className="social-nav" aria-label="Community links">
                            <a href="https://discord.com/invite/xv8dVtYtxa" target="_blank" rel="noreferrer" aria-label="Join The Pepes on Discord" title="Discord">
                                <MessageCircle aria-hidden="true" />
                            </a>
                            <a href="https://magiceden.io/ordinals/marketplace/the_pepes" target="_blank" rel="noreferrer" aria-label="View The Pepes on Magic Eden" title="Magic Eden">
                                <ShoppingBag aria-hidden="true" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default Navbar;
